<script>
    import ApplyToFundamental from './apply_to_fundamental.svelte';
    import ApplyToHero from './apply_to_hero.svelte';
    import FormFee from './form_fee.svelte';
    import {getContext} from 'svelte';
    const {url} = getContext('APP');
    const formDetail = Object.fromEntries(new URLSearchParams($url.search));
</script>
<section>

    {#if (formDetail.name === 'FundamentalsOfEntrepreneurship' || formDetail.name === 'CorporateInnovation' ||
        formDetail.name === 'Blockchain' || formDetail.name === 'CorporateAccelerator') &&
    (formDetail.FormNo === 'firstform' || formDetail.FormNo === 'secondform' ||
        formDetail.FormNo === 'thirdform' || formDetail.FormNo === 'submitform')}
        <ApplyToFundamental/>
    {/if}
    {#if (formDetail.name === 'HeroTraining' || formDetail.name === 'KanooInnovationHub' ||
          formDetail.name === 'HouseOfCeek') &&
          (formDetail.FormNo === 'firstform' || formDetail.FormNo === 'secondform' ||
    formDetail.FormNo === 'thirdform' || formDetail.FormNo === 'forthform' || formDetail.FormNo === 'submitform')}
        <ApplyToHero/>
    {/if}
    {#if (formDetail.name === 'VCX' || formDetail.name === 'investor' || formDetail.name === 'Government')}
        <FormFee/>
    {/if}
</section>

